import script from "./ParentPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ParentPage.vue?vue&type=script&setup=true&lang=js"

import "./ParentPage.vue?vue&type=style&index=0&id=e38b3054&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e38b3054"]])

export default __exports__